import { jsx as _jsx } from "react/jsx-runtime";
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { ModelsContextProvider } from './context/modelContext';
const queryClient = new QueryClient();
const container = document.getElementById('root');
if (container) {
    const root = createRoot(container);
    root.render(_jsx(QueryClientProvider, { client: queryClient, children: _jsx(ModelsContextProvider, { children: _jsx(BrowserRouter, { children: _jsx(App, {}) }) }) }));
}
